import { Fragment, PropsWithChildren } from 'react';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { IconClose } from '@/features/icons';
interface Props extends PropsWithChildren {
  closeHandler: () => void;
  isOpen: boolean;
}
const InteractifyModal = ({
  closeHandler,
  isOpen,
  children
}: Props) => {
  return <Transition appear show={isOpen} as={Fragment} data-sentry-element="Transition" data-sentry-component="InteractifyModal" data-sentry-source-file="modal.tsx">
            <Dialog as='div' className='relative z-modal' onClose={closeHandler} initialFocus={undefined} data-sentry-element="Dialog" data-sentry-source-file="modal.tsx">
                <TransitionChild as={Fragment} enter='ease-out duration-300' enterFrom='opacity-0' enterTo='opacity-100' leave='ease-in duration-200' leaveFrom='opacity-100' leaveTo='opacity-0' data-sentry-element="TransitionChild" data-sentry-source-file="modal.tsx">
                    <div className='fixed inset-0 bg-black bg-opacity-80' />
                </TransitionChild>

                <div className='fixed inset-0'>
                    <div className='flex h-full w-full items-center justify-center'>
                        <TransitionChild as={Fragment} enter='lg:ease-out lg:duration-300 transition ease duration-300 transform lg:transform-none' enterFrom='lg:opacity-0 lg:scale-95 translate-y-full' enterTo='lg:opacity-100 lg:scale-100 opacity-100 translate-y-0' leave='lg:ease-in lg:duration-200 transition ease duration-200 transform lg:transform-none' leaveFrom='lg:opacity-100 lg:scale-100 opacity-100 translate-y-0' leaveTo='lg:opacity-0 lg:scale-95 translate-y-full' data-sentry-element="TransitionChild" data-sentry-source-file="modal.tsx">
                            <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="modal.tsx">
                                <button onClick={closeHandler} className='hidden lg:inline-block'>
                                    <IconClose className='absolute right-6 top-6 flex h-10 w-10 text-white' data-sentry-element="IconClose" data-sentry-source-file="modal.tsx" />
                                </button>

                                {children}
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </Transition>;
};
export default InteractifyModal;